/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild,OnDestroy, HostListener } from '@angular/core';
import { FunCollectionService } from 'src/app/common/common-functions/fun-collection.service';
import { DataStorageService } from 'src/app/dataservices/data-storage.service';
import { FileUploadService } from 'src/app/dataservices/file-upload.service';
import { SafeUrl } from '@angular/platform-browser';
import * as htmlToImage from 'html-to-image';
import { UserStoryService } from 'src/app/dataservices/userStory/user-story.service';
import { MasterserviceService } from 'src/app/dataservices/master-service/masterservice.service';
/**
 * Interface import.
 */
import { EventDataKey } from 'src/app/analytics-event/analytics.model';

/**
 * rxjs imports
 */
import { Subscription } from 'rxjs';

/**
 * service imports
 */
import { FileUploadKeeperService } from 'src/app/dataservices/file-upload-keeper.service';
import { GetService } from 'src/app/dataservices/get.service';
import { JwtDecodeService } from 'src/app/dataservices/jwt-decode.service';
import { PostApiService } from 'src/app/dataservices/post-api.service';

/**
 * constant imports
 */
import { CREATE_STORY } from 'src/app/interface/keeperResponseConstant/responseConst';
/**
 * Constant imports.
 */
import { STORY_CREATION_OPTIONS, STORY_CREATION_OPTIONS_SVG, CREATION_TEXT_TYPE, TEMPLATE_TYPE, STORY_BACKGROUND_CODES, NUMBERS, STORY_TYPES, PRODUCT_TYPE_CONSTANT, CTA_TYPE, CTA_TYPE_ACTION, WEBINAR_STATUS, CREATE_STORY_TYPES, STORY, STORY_CREATION_TYPE, STORY_DEFAULT_DURATION, CALLING_FROM, SCREEN_NAME, PRODUCT_TYPE_CONSTANT_NAME, ACTION_ON, TRANSACTION_TYPE, ACTION_TYPE } from '../../../../app/constants/app.constants';

/**
 * Service imports.
 */
import { NewLanguageService } from 'src/app/dataservices/new-language/new-language.service';
import { AnalyticsEventService } from 'src/app/analytics-event/analytics-event.service';
import { EVENT_NAME } from 'src/app/analytics-event/analytics.constant';

/**
 * sdk imports
 */
import { Analytics } from 'analytics2.0';
import { ENTRY, ERROR, EXIT, SUBMIT, SUCCESS } from 'analytics2.0/dist/core/constants/analytic.interface';

/**
 * Used to create the stories.
 */
@Component({
  selector: 'app-story-creation',
  templateUrl: './story-creation.component.html',
  styleUrls: ['./story-creation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoryCreationComponent implements OnInit, OnDestroy {

  /**
   * Flag for the creation mode modal.
   * Flag for the custom template.
   * For the respective product type image.
   * For the story thumbnail.
   * Text added required.
   * Pre defined story text.
   */
  @Input() isStoryCreationMode: boolean;
  @Input() isCustomTemplate: boolean;
  @Input() productImage: SafeUrl = 'assets/images/grandround/image_placeholder.svg';
  @Input() productData: any;
  @Input() storyThumbnail = { src: '', gradient: 'linear-gradient(0deg, #E0FF9C 0%, #38D5E0 100%)' };
  @Input() isStoryTyping: boolean;
  @Input() storyText: string;
  @Input() templates;
  @Input() customTemplateType: number;
  @Input() repostingFileCode: string;

  @Input() templateList: any;

  @Input() backGroundCode: any;
  @Input() showCreationTexting: boolean;
  @Input() callingFrom: string = SCREEN_NAME.STORY_CREATION;

  /**
   * Emit the hidden and uploading event outside.
   */
  @Output() emitOnHidden: EventEmitter<void> = new EventEmitter();
  @Output() emitOnUploading: EventEmitter<void> = new EventEmitter();


  public  tagListOffset = 1;

  public STORY_TYPES = STORY_TYPES;
  /**
   * flag to show discard pop up
   */
  public discardStory = false;
  public createStoryData = {
    fileCode : '',
    fileType: '',
    carouselCode: '',
    templateCode: '',
    storyType: '',
    storyTitle: '',
    cta: [],
    text: '',
    backgroundCode: '',
    pharmaRepostStoryCode: '',
    extra: {groupCode:{association:[],speciality:[],community:[],channel:[]},entityCode:null,entityType:null},
    entityType: '',
    deeplink: '',
    version: 1,
    tagUser: []
  };

  public uploadButtonDisabled = true;

  public failedUpload = false;

  public selectedTaggedUsers = [];
  public storyUploadProgress = false;


  public defaultImage: string;

  /**
   * is pharma repost
   */
  public isPharmaRepost = false;

  /**
   * flag to show tag component
   */
  public showTagOnWeb = false;
  /**
   * to store product type and product id
   */
  productType = this.dss.user_story_productType;

  productTypeId = this.dss.user_story_productTypeId;

  /**
   * to store deeplink
   */
  public deeplink: string;

  /**
   * back ground image for posting story as template
   */
  public backGroundImage: string;
  /**
   * master data
   */
  public masterData;

  /**
   * for api subscription
   */
  private subscriptions: Subscription = new Subscription();
  /**
   * flag variable to show user tag list or not
   */
  public showUserList = false;
  /**
   * template repost flag
   */
  public templateRepost = false;
  /**
   * story creation text type constant.
   * template type constant.
   * Available options for the creation.
   */
  public storyCreationTextType = CREATION_TEXT_TYPE;
  public templateType = TEMPLATE_TYPE;
  public creationOptionsList = [
    { id: STORY_CREATION_OPTIONS.ADD_TEXT, text: this.mls.languageText.stories_creation.key8, img: STORY_CREATION_OPTIONS_SVG.ADD_TEXT }
  ];
  public ctaList = [];
  public storyCreateThumbnail;

  /**
   * public tag user list
   */
  public tagUserList:any[] = [];

  public storyType: string;
  public currentDate = new Date().getTime().toString();

  public startTime;
  stopEventListening = false;
  /**
   * Necessary instances required.
   */
  constructor(
    private cd: ChangeDetectorRef,
    public mls: NewLanguageService,
    private funCollectionService: FunCollectionService,
    private dss:DataStorageService,
    public fileUsFork: FileUploadService,
    private fileUpload: FileUploadKeeperService,
    private getSer: GetService,
    private jwtSer: JwtDecodeService,
    private postSer: PostApiService,
    public storyServ: UserStoryService,
    private masterSer: MasterserviceService,
    private analyticsSdk: Analytics
  ) { }
  ngOnDestroy(): void {
  this.stopEventListening = false;
  this.emitOnHidden.emit();
  }


  /**
   * get defaultContent for storis
   */
  getDefaultContent(): Promise<void> {
    return new Promise((resolve) => {
      this.subscriptions.add(this.getSer.getDefaultContentStories(this.productType, this.productTypeId).subscribe(res => {
        if (res?.lc) {
          this.storyText = res.lc.description;
          if (this.productType && !this.productTypeId) {
            this.productImage = res.lc.fileUrl;
            this.repostingFileCode = res.lc.fileCode;
            this.storyServ.fileCodeUrlMap.set(res.lc.fileCode, res.lc.fileUrl);
          }
          this.cd.markForCheck();
          resolve();
        }
      }));
    });
  }
  /**
   * Used to handle share content.
   */
  shareContent(): void {
    this.subscriptions.add(this.getSer.getShare(this.productType, this.productTypeId).subscribe(resData => {
      this.jwtSer.decodeData(resData).then(shareData => {
        if (shareData.status == 1) {
          this.deeplink = shareData.data.share_content.share_link;
        }
      });
    }));
  }
  @HostListener('window:beforeunload.out-zone', ['$event'])
  beforeUnloadHandler() {
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
      entity_code: 0,
      current_screen_name: SCREEN_NAME.STORY_CREATION,
      start_time: parseInt(this.startTime),
      end_time: new Date().getTime()
    }
    this.analyticsSdk.analyticService.EXIT(exitData)
    return true;
  }
  async ngOnInit(): Promise<void> {
    this.stopEventListening = true;
    this.startTime = this.getTimeString();
    document.addEventListener('visibilitychange', () => {
      if (document.hidden && this.stopEventListening) {
        const exitData: EXIT = {
          entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
          entity_code: 0,
          current_screen_name: SCREEN_NAME.STORY_CREATION,
          start_time: parseInt(this.startTime),
          end_time: new Date().getTime()
        }
        this.analyticsSdk.analyticService.EXIT(exitData)
      }
      else {
        this.startTime = this.getTimeString();
        const entryData: ENTRY = {
          entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
          entity_code: 0,
          source: '',
          current_screen_name: SCREEN_NAME.STORY_CREATION,
          start_time: parseInt(this.startTime)
        }
        this.analyticsSdk.analyticService.ENTRY(entryData);
      }
   });
    this.masterData = this.masterSer.masterApiData;
    const entryData: ENTRY = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
      entity_code: 0,
      source:this.dss.story_creating_type != STORY_CREATION_TYPE.CREATE_STORY ? SCREEN_NAME.STORY_PLAY : this.funCollectionService.currentScreename,
      current_screen_name: SCREEN_NAME.STORY_CREATION,
      start_time: parseInt(this.startTime)
    }
    this.analyticsSdk.analyticService.ENTRY(entryData);
    this.storyType = this.dss.storyType;
    this.createStoryData.fileType = this.dss.StoryFileType;
    this.templateRepost = this.dss.templateRepost;
    this.productType = this.dss.user_story_productType;
    this.productTypeId = this.dss.user_story_productTypeId;
    if (this.dss.storyType === CREATE_STORY_TYPES.REPOST || this.dss.storyType === CREATE_STORY_TYPES.STORY || this.dss.storyType === CREATE_STORY_TYPES.CERTIFICATE) {
      await this.getDefaultContent();
      this.showCreationTexting = true;
    } else {
      this.showCreationTexting = true;
    }
    if (this.dss.story_creating_type === STORY_CREATION_TYPE.CREATE_STORY) {
      this.dss.storyDuration = STORY_DEFAULT_DURATION;
      if (this.productType &&  this.productTypeId) {
        this.shareContent();
        // TODO: RAHUL: To remove settimeout
        if(this.productType != PRODUCT_TYPE_CONSTANT.CME) {
          setTimeout(() => {
            this.clickToCapture(this.screen.nativeElement, '').then(res => {
              this.productImage = res;
              this.cd.markForCheck();
              this.cd.detectChanges();
            }).catch(error => {
               this.productImage = 'https://d1bpj5pexoafo2.cloudfront.net/fit-in/500x500/images/category-images/yxy/doctor/Cardiology.jpg';
              this.cd.markForCheck();
              this.cd.detectChanges();
            });
        }, 500);
        }
        }
    }
    else if (this.dss.story_creating_type === STORY_CREATION_TYPE.REPOST_STORY) {
      this.shareContent();
      let imageValue = '';
      if (this.storyServ.validateUrl(this.repostingFileCode)) {
        imageValue = this.repostingFileCode;
      }
      else if (this.storyServ.fileCodeUrlMap.has(this.repostingFileCode)) {
        imageValue = this.storyServ.fileCodeUrlMap.get(this.repostingFileCode);
      }
      else {
        this.fileUpload.loadPreSignedUrl(this.repostingFileCode, 'DQ').then(res => {
          imageValue = res;
        });
        this.cd.markForCheck();
      }
      if (this.storyType === STORY_TYPES.PHARMA || this.storyType === STORY_TYPES.PHARMAREPOST) {
        this.isPharmaRepost = true;
        if (this.dss.StoryFileType === 'VIDEO') {
          this.storyServ.StoryshowLoader.next(true);
          const videoUrl = this.storyServ.fileCodeUrlMap.get(this.repostingFileCode);
          const videoBlob =  await this.storyServ.fetchVideoAsBlob(videoUrl);
          await this.storyServ.getVideoThumbnail(videoBlob).then(res => {
            this.dss.storyVideoRpostThumbnail=res?.data;
             this.backGroundImage = this.dss.storyVideoRpostThumbnail;
             this.storyServ.StoryshowLoader.next(false);
             this.cd.markForCheck();
             this.cd.detectChanges();
          }).catch(error => {
            // No code
          });
        }
        else {
          this.backGroundImage = imageValue;
        }
        this.createStoryData.pharmaRepostStoryCode = this.dss.storyRepostCode;
      }
      if (this.storyType === STORY_TYPES.TEMPLATE) {
        this.backGroundImage = imageValue;
      }
      else {
        this.productImage = imageValue;
      }
    }
    this.uploadButtonDisabled = false;
    this.cd.markForCheck();

  }

  /**
   * Emit creation pop hide.
   */
  onHidden(): void {
    this.discardStory = true;
  }
  onClose(): void {
    this.emitOnHidden.emit();
  }
  /**
   * clear search
   */
  clearSearch(): void {
    if (document.querySelector<HTMLInputElement>('#userSearch')) {
      document.querySelector<HTMLInputElement>('#userSearch').value = '';
    }
    this.onScrollSearch({offset: 1, keyword: '' });
  }
  /**
   *
   * @param element
   * @returns
   */
  showTagFunctionality(event): void {
    if (event) {
      this.analyticsSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,0,SCREEN_NAME.STORY_CREATION, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.TAG_USER, null);
      this.showTagOnWeb = true;
      this.getTagUserList('', 1);
      this.showUserList = true;
      this.cd.markForCheck();
    }
    else {
      this.analyticsSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,0,SCREEN_NAME.STORY_CREATION, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.SAVE_TAGGED_USER, null);
      this.clearSearch();
      this.showUserList = false;
      this.showTagOnWeb = false;
    }
  }
  /**
   * remove user for taging
   * @param element
   * @returns
   */
  removeUser(event): void {
    this.storyServ.storyTagList = this.storyServ.storyTagList.filter(function( obj ) {
      return obj.uuid !== event.uuid;
  });
  this.selectedTaggedUsers = this.selectedTaggedUsers.filter(function( obj ) {
    return obj !== event.uuid;
});
  this.storyServ.creation_view_update.next(1);
  }
  /**
   * add user for tagging
   * @param event
   */
  addUser(event): void {
    if (this.storyServ.storyTagList.length === 5 ) {
      return;
    }
    this.storyServ.storyTagList.push(event);
    this.selectedTaggedUsers.push(event.uuid);
    // this.dss.tag_user_list.push(event);
    this.storyServ.creation_view_update.next(1);
    this.cd.markForCheck();
  }
  async clickToCapture(element, previousDataUrl, firstCall = true): Promise<any> {
    const node = element;
    let resultUrl = '';
    if (firstCall === true) {
      for (let i = 0; i < 3;i++) {
        await htmlToImage.toPng(node, {skipFonts: true, fontEmbedCSS: '', pixelRatio: 2}).then(async dataUrl => {
          const img = new Image();
          img.src = dataUrl;
          resultUrl = dataUrl?.length > resultUrl.length ? dataUrl : resultUrl;
        });
      }
    }
    previousDataUrl = resultUrl;
    return await htmlToImage.toPng(node, {skipFonts: true, fontEmbedCSS: '', pixelRatio: 2}).then(async dataUrl =>  {
        const img = new Image();
        img.src = dataUrl;
        if (previousDataUrl.length != dataUrl.length && previousDataUrl.length < dataUrl.length) {
          previousDataUrl = dataUrl;
          return await this.clickToCapture(element, previousDataUrl);
        }
        else {
          return previousDataUrl;
        }
      })
      .catch(function (error) {
        //  no code
      });
  }

  /**
   * Emit on uploading creation.
   *  @ViewChild('screen', { static: true }) screen: ElementRef<any>;
   */
  @ViewChild('screen') screen: ElementRef<any>;

  @ViewChild('thumbnailView') thumbnailView: ElementRef<any>;

  // TODO: RAHUL: To use variables from constant

  async onUploading(): Promise<void> {
    if (this.storyUploadProgress === true || this.uploadButtonDisabled === true ) {
      return;
    }
    this.storyUploadProgress = true;
    this.cd.markForCheck();
    this.emitOnUploading.emit();
    this.createStoryData.text = this.storyText;
    this.createStoryData.tagUser = this.selectedTaggedUsers;
      let productFile;
      const fileName = 'product_' + Date.now();
      if (!this.repostingFileCode) {
        this.createStoryData.fileType = STORY_TYPES.IMAGE;
        if (this.storyServ.validateUrl(this.productImage)) {
          productFile =  await this.fileUpload.getFileFromUrl(this.productImage, fileName );
        }
        else {
          productFile = this.fileUpload.dataUrlToFile(this.productImage,fileName);
        }
        const productFileName =  this.fileUpload.getValidFileName(productFile.name);
        await this.fileUpload.uploadFileOnKeeper(productFile,productFileName, 'DQ', 'IN', 'PUBLIC', 'IMAGE').then(res => {
          this.createStoryData.fileCode = res.fileCode;
          this.storyServ.fileCodeUrlMap.set(res.fileCode, res.signedUrl);
        }).catch(error => {
          this.storyUploadProgress = false;
          this.failedUpload = true;
          const errorData: ERROR = {
            entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
            entity_code: 0,
            current_screen_name: SCREEN_NAME.STORY_CREATION,
            start_time: new Date().getTime(),
            transaction_type: TRANSACTION_TYPE.STORY_CREATION,
            type: 'Keeper upload error'
          };
          this.analyticsSdk.analyticService.ERROR(errorData);
          this.cd.markForCheck();
        });
      }
      else {
        if (this.storyServ.validateUrl(this.repostingFileCode)) {
          productFile =  await this.fileUpload.getFileFromUrl(this.repostingFileCode, fileName );
          const productFileName =  this.fileUpload.getValidFileName(productFile.name);
          await this.fileUpload.uploadFileOnKeeper(productFile,productFileName, 'DQ', 'IN', 'PUBLIC', 'IMAGE').then(res => {
            this.createStoryData.fileCode = res.fileCode;
            this.storyServ.fileCodeUrlMap.set(res.fileCode, res.signedUrl);
          }).catch(error => {
            this.storyUploadProgress = false;
            this.failedUpload = true;
            const errorData: ERROR = {
              entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
              entity_code: 0,
              current_screen_name: SCREEN_NAME.STORY_CREATION,
              start_time: new Date().getTime(),
              transaction_type: TRANSACTION_TYPE.STORY_CREATION,
              type: 'Keeper upload error'
            };
            this.analyticsSdk.analyticService.ERROR(errorData);
            this.cd.markForCheck();
          });
        }
        else {
          this.createStoryData.fileCode = this.repostingFileCode;
        }
      }
      if (!this.storyUploadProgress) {
        this.failedUpload = true;
        this.cd.markForCheck();
        return;
      }
    let carouselImage;
    await this.clickToCapture(this.thumbnailView.nativeElement, '').then(res => {
      carouselImage = res;
    }).catch(error => {
      this.storyUploadProgress = false;
      this.failedUpload = true;
      const errorData: ERROR = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
        entity_code: 0,
        current_screen_name: SCREEN_NAME.STORY_CREATION,
        start_time: new Date().getTime(),
        transaction_type: TRANSACTION_TYPE.STORY_CREATION,
        type: 'Screen Shot Error'
      };
      this.analyticsSdk.analyticService.ERROR(errorData);
    });
    if (!this.storyUploadProgress) {
      this.cd.markForCheck();
      this.failedUpload = true;
      return;
    }
    if (carouselImage === null || carouselImage === undefined) {
      this.storyUploadProgress = false;
      this.failedUpload = true;
      this.cd.markForCheck();
      return;
    }
    const carouselImageFile = this.fileUpload.dataUrlToFile(carouselImage, 'carouselImage_' + Date.now());
    const carouselImageFileName = this.fileUpload.getValidFileName(carouselImageFile.name);
    await this.fileUpload.uploadFileOnKeeper(carouselImageFile,carouselImageFileName, 'DQ', 'IN', 'PUBLIC', 'IMAGE').then(res => {
      this.storyServ.fileCodeUrlMap.set(res.fileCode, res.signedUrl);
      this.createStoryData.carouselCode = res.fileCode;
    }).catch(error => {
      this.storyUploadProgress = false;
      const errorData: ERROR = {
        entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
        entity_code: 0,
        current_screen_name: SCREEN_NAME.STORY_CREATION,
        start_time: new Date().getTime(),
        transaction_type: TRANSACTION_TYPE.STORY_CREATION,
        type: 'Keeper upload error'
      };
      this.analyticsSdk.analyticService.ERROR(errorData);
    });
    if (!this.storyUploadProgress) {
      this.failedUpload = true;
      this.cd.markForCheck();
      return;
    }
    this.createStoryData.storyType = this.dss.storyType;
    this.createStoryData.templateCode = this.dss.templateValue;
    if (this.storyType === STORY_TYPES.PHARMA || this.storyType === STORY_TYPES.PHARMAREPOST) {
      this.ctaList = this.dss.storyRepostCta;
      this.createStoryData.cta = this.ctaList;
    }
   else if (this.storyType !== STORY_TYPES.TEMPLATE) {
      this.createStoryData.extra.entityType = this.productType;
      this.createStoryData.extra.entityCode = this.productTypeId;
      this.createStoryData.deeplink = this.deeplink;
      if ( this.productType === PRODUCT_TYPE_CONSTANT.FEED || this.productType === PRODUCT_TYPE_CONSTANT.WEBINAR || this.productType === PRODUCT_TYPE_CONSTANT.ARTICLE || this.productType === PRODUCT_TYPE_CONSTANT.DOCTALKS) {
        this.generateCta();
        this.createStoryData.cta = this.ctaList;
      }
      else if ( this.productType === PRODUCT_TYPE_CONSTANT.CME) {
        // no code
      }
    }
    else if (this.storyType === STORY_TYPES.TEMPLATE) {
      this.createStoryData.templateCode = this.dss.templateValue;
      this.createStoryData.storyType = CREATE_STORY_TYPES.TEMPLATE;
      this.generateCta();
      this.createStoryData.cta = this.ctaList;
    }
    this.createStoryData.entityType = STORY.STORY;
    this.postStory();
  }
  // TODO: RAHUL: to handle response code through constants
  /**
   * function to call create story api and handle story listing locally
   */
  postStory(): void {
    this.subscriptions.add(this.postSer.createUserStory('1', this.createStoryData).subscribe(res => {
      if (res) {
        if (res.mc === 'S035001') {           
          this.storyUploadProgress = false;
          this.failedUpload = true;
          this.cd.markForCheck();
          const succesData: SUCCESS = {
            entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
            entity_code: 0,
            current_screen_name: SCREEN_NAME.STORY_CREATION,
            start_time: new Date().getTime(),
            transaction_type: TRANSACTION_TYPE.STORY_CREATED
          }
          this.analyticsSdk.analyticService.SUCCESS(succesData);
          this.emitOnHidden.emit();
          this.storyServ.handleStoryDataState(this.dss.uuid,this.createStoryData);
        }
        else {
          const errorData: ERROR = {
            entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
            entity_code: 0,
            current_screen_name: SCREEN_NAME.STORY_CREATION,
            start_time: new Date().getTime(),
            transaction_type: TRANSACTION_TYPE.STORY_CREATION,
            type: res.m
          };
          this.analyticsSdk.analyticService.ERROR(errorData);
          this.storyUploadProgress = false;
          this.failedUpload = true;
          this.cd.markForCheck();
          return;
        }
      }
    }));
  }
  /**
   * generate story cta
   */
  generateCta(): void {
    const primaryCta ={
      enabled: 1,
      text: '',
      id: '',
      type: '',
      url: this.deeplink,
      ctaType: CTA_TYPE.PRIMARY
    };
    if (this.storyType ===  CREATE_STORY_TYPES.TEMPLATE) {
      primaryCta.text = this.mls.languageText.stories_creation.key37;
      primaryCta.id = '';
      primaryCta.type = CREATE_STORY_TYPES.REPOST;
      this.ctaList.push(primaryCta);
    }
    else if (this.storyType === STORY_TYPES.PHARMA || this.storyType === STORY_TYPES.PHARMAREPOST ) {
      this.ctaList = this.dss.storyRepostCta;
    }
    else {
     primaryCta.type =  CTA_TYPE_ACTION.DEEPLINK;
     if (this.productType === PRODUCT_TYPE_CONSTANT.WEBINAR) {
      const status = this.productData?.status;
      if (status === WEBINAR_STATUS.UPCOMING) {
        primaryCta.text = this.mls.languageText.stories_creation.key11;
      }
      else if (status === WEBINAR_STATUS.LIVE) {
        primaryCta.text = this.mls.languageText.stories_creation.key12;
      }
      else if (status === WEBINAR_STATUS.END) {
        primaryCta.text = this.mls.languageText.stories_creation.key12;
      }
      else {
        primaryCta.text = this.mls.languageText.stories_creation.key12;
      }
    }
    else if (this.productType === PRODUCT_TYPE_CONSTANT.FEED) {
      primaryCta.text = this.mls.languageText.stories_creation.key10;
    }
    else if (this.productType === PRODUCT_TYPE_CONSTANT.ARTICLE) {
      primaryCta.text = this.mls.languageText.stories_creation.key13;
    }
    else if (this.productType === PRODUCT_TYPE_CONSTANT.DOCTALKS) {
      primaryCta.text = this.mls.languageText.stories_creation.key12;
    }
    const secondaryCta = {
      enabled: 1,
      text: this.mls.languageText.stories_creation.key37,
      id: '',
      type: CTA_TYPE_ACTION.REPOST,
      url: '',
      ctaType: CTA_TYPE.SECONDARY
  };
  this.ctaList.push(primaryCta);
  this.ctaList.push(secondaryCta);
    }
  }
  /**
   * Enable the options for the creation in mobile web.
   */
  storyOptionAction(status: number): void {
    if (status === STORY_CREATION_OPTIONS.ADD_TEXT) {
      this.onTextFocus();
      this.isStoryTyping = true;
    }
  }
  /**
   * template change
   */
  changeTemplate(event) : void {
    this.backGroundImage = event;
    this.repostingFileCode = event;
    this.cd.markForCheck();
    this.cd.detectChanges();
  }
  /**
   * Set the template for the creation.
   */
  selectTemplate(event): void {
    if (event) {
       this.storyCreateThumbnail = event;
      this.createStoryData.backgroundCode = event.src;
      this.cd.detectChanges();
    }
  }
  /**
   *
   * @param keyWord
   * @param offSet
   */
  onScrollSearch(event): void {
    if (event.offSet === 1) {
      this.storyServ.storyTagList = [];
      this.tagListOffset = 1;
      this.cd.markForCheck();
    }
    this.getTagUserList(event.keyword, event.offset);
  }

  /**
   * get tag user list
   * @param keyWord
   * @param offSet
   */
  getTagUserList(keyWord, offset): void {
    this.subscriptions.add(this.getSer.getStoryUserSearchList(keyWord, offset).subscribe(res => {
      if (res?.mc === 'S035014') {
        if (offset === 1) {
          this.dss.tag_user_list = [];
          this.tagListOffset = 1;
        }
        this.dss.tag_user_list.push(...res.lc);
        this.tagListOffset = this.tagListOffset + 1;
      }
      else if (res?.status === 204 && offset === 1) {
        this.dss.tag_user_list = [];
      }
      else if (res?.status === 204) {
        this.tagListOffset = 0;
      }
      this.cd.markForCheck();
    }));
  }
  onDiscard(): void {
    this.analyticsSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,0,SCREEN_NAME.STORY_CREATION, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.DISCARD_CREATION, null);
    this.emitOnHidden.emit();
    const exitData: EXIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
      entity_code: 0,
      current_screen_name: SCREEN_NAME.STORY_CREATION,
      start_time: new Date().getTime(),
      end_time: new Date().getTime()
    }
    this.analyticsSdk.analyticService.EXIT(exitData)
  }

  onTextFocus(): void {
    this.analyticsSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY, 0, SCREEN_NAME.STORY_CREATION, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.ADD_TEXT, null)
  }

  onReupload(): void {
    this.failedUpload = false;
    this.analyticsSdk.analyticService.CLICK(PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,0, SCREEN_NAME.STORY_CREATION, CTA_TYPE.BUTTON, ACTION_TYPE.CLICK, ACTION_ON.CREATION_TRY_AGAIN, null);

    this.onUploading();
  }

  uploadStory(): void {
    const submitData: SUBMIT = {
      entity_type: PRODUCT_TYPE_CONSTANT_NAME.USER_STORY,
      entity_code: 0, 
      current_screen_name: SCREEN_NAME.STORY_CREATION,
      action_on: ACTION_ON.CREATE_STORY,
      cta_type: CTA_TYPE.BUTTON,
      start_time: new Date().getTime(),
      action_type: ACTION_TYPE.CLICK
    }
    this.analyticsSdk.analyticService.SUBMIT(submitData);
    this.onUploading();
  }
  /**
    * Get the current time in string.
    */
  getTimeString(): string {
    return new Date().getTime().toString();
  }
}
